import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { actions } from 'pages/tours/store';
import { goToPayment, orderNewTour } from 'pages/tours/actions';
import { stepsDataSelector } from 'pages/tours/selectors';
import { infoMessage, STEPS } from 'pages/tours/create/constants';
import {
  dateWithDashesSpaceAM,
  dateWithDashesSpaceFullHours24,
  getWeekDayByMoment,
} from 'helpers/momentHelpers';
import {
  CIRCULAR_PROGRESS_SIZE_NAMES,
  CIRCULAR_PROGRESS_TYPES,
} from 'components/circularProgress/constants';

import { OrderSummary } from 'pages/tours/create/new-steps/components/order-summary';
import { CircularProgress } from 'components';
import { showTotalPrice } from 'helpers/showTotalPrice';

// images
import infoImg from 'assets/images/info-mesaage.svg';

export const StepThree = (props) => {
  const {
    filteredServices,
    filteredCompanyServices,
    getSubtotal,
    selectedPackage,
    selectedServices,
    selectedCompanyServices,
    selectedPackageServiceIds,
    getHST,
    getTotal,
    packages,
    chosenOptionsObj,
    getOtherTotal,
    getOtherHts,
    getCompanyServicesTotal,
    salesOptions,
  } = props;
  const [isPayingProcess, setIsPayingProcess] = useState(false);

  const showTotal = showTotalPrice(getOtherTotal);

  const sendingCompanyServices = [];

  selectedCompanyServices.forEach((elementId) => {
    const optionId = chosenOptionsObj[elementId] || null;
    sendingCompanyServices.push({ id: elementId, option_id: optionId });
  });

  const dispatch = useDispatch();
  const stepsData = useSelector(stepsDataSelector);

  const navigate = useNavigate();
  const formattedDate = dateWithDashesSpaceFullHours24(stepsData.date);

  const tourCreationData = {
    ...stepsData,
    address: stepsData.address.endsWith('Canada')
      ? stepsData.address
      : stepsData.address +
        ',' +
        stepsData.city +
        ',' +
        stepsData.province +
        ', Canada',
    package: selectedPackage.id,
    sale_options: salesOptions?.map((elem) => elem?.id),
    date: formattedDate,
    company_services: sendingCompanyServices,
    company_total_cost: getCompanyServicesTotal,
  };

  const redirectToPayment = ({ id, is_main_service }) => {
    dispatch(goToPayment({ id, is_main_service }))
      .then((res) => {
        window.open(res.data.url, '_self');
      })
      .catch(() =>
        navigate('/payment-declined', { state: { propertyListingFlow: true } })
      );
  };

  const createTour = () => {
    setIsPayingProcess(true);
    dispatch(orderNewTour(tourCreationData))
      .then((res) => {
        dispatch(actions.setSelectedSqFt(0));
        dispatch(actions.setSelectedServices([]));
        dispatch(actions.setChosenOptionsObj({}));
        redirectToPayment({ id: res.data.id, is_main_service: 1 });
      })
      .catch(() => {
        navigate('/payment-declined', { state: { propertyListingFlow: true } });
      });
  };

  return (
    <div className="dashboardMain">
      <div className="card">
        <h3 className="heading3 step_three_heading3">{STEPS.finalize}</h3>
        <div className="row">
          <div className="col-xxl-9">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">{STEPS.address}</label>
                  <div className="relative min-width-260">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={stepsData?.address}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">{STEPS.city}</label>
                  <div className="relative min-width-260">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={stepsData?.city}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">{STEPS.province}</label>
                  <div className="relative min-width-260">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={stepsData?.province}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">{STEPS.postal_code}</label>
                  <div className="relative min-width-260">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={stepsData?.postal_code}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">{STEPS.unit_number}</label>
                  <div className="relative min-width-260">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={stepsData?.unit_number}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">{STEPS.shooting_date}</label>
                  <div className="relative min-width-260">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`${
                        stepsData?.date
                          ? getWeekDayByMoment(stepsData?.date) +
                            ', ' +
                            dateWithDashesSpaceAM(stepsData?.date)
                          : ''
                      }`}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="packageStep">
            <div className="row">
              <div className="col-xxl-6">
                <OrderSummary
                  title={STEPS.order_summary}
                  packages={packages}
                  selectedPackage={selectedPackage}
                  selectedCompanyServices={selectedCompanyServices}
                  selectedPackageServiceIds={selectedPackageServiceIds}
                  selectedServices={selectedServices}
                  filteredServices={filteredServices}
                  filteredCompanyServices={filteredCompanyServices}
                  getSubtotal={getSubtotal}
                  getHST={getHST}
                  getTotal={getTotal}
                  salesOptions={salesOptions}
                />
              </div>
              <div className="col-xxl-6 ps-xxl-5">
                <div className="infoMessage">
                  <div className="infoHead">
                    <img src={infoImg} alt="Info Message" />
                    <h3 className="infoTitle">{STEPS.payment_message}</h3>
                  </div>
                  <p className="infoText">{infoMessage}</p>
                </div>
              </div>
              {!!stepsData?.company_services?.length && (
                <div className="later_charge_container col-lg-6">
                  <div className="cardCharge cstWidth">
                    <h3 className="later_charge_title">{STEPS.charge_later}</h3>
                    <p className="note">{STEPS.charge_text}</p>
                    <div className="titleCharge">
                      <h4>{STEPS.more_services}</h4>
                      <h4>{STEPS.price}</h4>
                    </div>
                    <ul>
                      {filteredCompanyServices.map((service, i) => (
                        <li key={i}>
                          <span>
                            {service.title.charAt(0).toUpperCase() +
                              service.title.slice(1)}
                          </span>{' '}
                          {service.price || service?.price_fixed
                            ? `$${service.price || service?.price_fixed}`
                            : STEPS.not_specified}
                        </li>
                      ))}
                    </ul>
                    <div className="totalCard">
                      <div className="amount">
                        <p className="subTotal">
                          <span>{STEPS.subtotal}</span>{' '}
                          <strong>${getCompanyServicesTotal}</strong>
                        </p>
                        <p>
                          <span>{STEPS.hst}</span>{' '}
                          <strong>
                            {STEPS.hst_percent} (${getOtherHts})
                          </strong>
                        </p>
                      </div>
                      <div className="total later_charge_total">
                        <p>
                          <span>{STEPS.total}</span>{' '}
                          <strong>{showTotal}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="text-end footerCta">
            <button
              id="prev_button"
              className="btn cta-outline-primary mr-1"
              onClick={() => dispatch(actions.setCurrentStep(2))}
            >
              {STEPS.previous}
            </button>
            <button
              disabled={isPayingProcess}
              className="btn cta-primary"
              onClick={createTour}
            >
              {isPayingProcess ? (
                <CircularProgress
                  type={CIRCULAR_PROGRESS_TYPES.white}
                  size={CIRCULAR_PROGRESS_SIZE_NAMES.small}
                />
              ) : (
                `${STEPS.pay} $${getTotal}`
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
